import { call, put, select, takeLatest } from 'redux-saga/effects'
import { trackEvent } from '@/core/reducks/analytics'
import { getPositionName } from '../selectors/positions'
import * as stickyFiltersModule from '../modules/stickyFilters'
import * as positionsModule from '../modules/positions'
import { errorHandler } from '@/core/helpers/errorHelpers'

function* resetPositionDetailSaga() {
  yield put(stickyFiltersModule.toggleResetting(true))
  yield call(trackEvent, 'Company: Clear candidate list filters', {})

  try {
    const positionName = yield select(getPositionName)
    yield put(stickyFiltersModule.resetPositionDetailSuccess(positionName))
    yield put(positionsModule.toggleNotice(true))
  } catch (err) {
    yield call(errorHandler, err)
  }

  yield put(stickyFiltersModule.toggleResetting(false))
}

export default function* watchStickyFiltersSaga() {
  yield takeLatest(stickyFiltersModule.RESET_POSITION_DETAIL, resetPositionDetailSaga)
}
